var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "help-icon",
    d: "M-7160,2769a8.941,8.941,0,0,1-6.363-2.636A8.94,8.94,0,0,1-7169,2760a8.942,8.942,0,0,1,2.637-6.364A8.942,8.942,0,0,1-7160,2751a8.942,8.942,0,0,1,6.364,2.636A8.941,8.941,0,0,1-7151,2760a8.939,8.939,0,0,1-2.636,6.364A8.941,8.941,0,0,1-7160,2769Zm.148-6.85a1.123,1.123,0,0,0-1.2,1.115,1.147,1.147,0,0,0,1.2,1.139,1.146,1.146,0,0,0,1.2-1.139A1.123,1.123,0,0,0-7159.853,2762.149Zm-.351-5.121c.82,0,1.352.393,1.352,1,0,.48-.372.817-.8,1.208a2.659,2.659,0,0,0-1.149,2.022h1.891c0-.6.433-.978.891-1.382a2.75,2.75,0,0,0,1.213-2.175c0-1.428-1.219-2.316-3.18-2.316a4,4,0,0,0-3.545,1.678l1.516.888A2.12,2.12,0,0,1-7160.2,2757.029Z",
    transform: "translate(7169.001 -2751)",
    fill: "#eec214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.5b0d745c.svg";
export { ForwardRef as ReactComponent };